import React, { useEffect, useRef, useState } from "react";
import { Divider, IconButton, InputBase, Paper } from "@mui/material";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom"; 
import useOutsideClick from "./useOutsideClick";
import { initMapScript, extractAddress, lat_long } from "../../utils/functions";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";

const apiKey = "AIzaSyCGWOncKpScDee8tbJMQrn9hAmform-yDw";

function SearchBarNew() {
  const navigate = useNavigate(); 
  useEffect(() => {
    initMapScript().then(initAutocomplete);
  }, []);
  const searchInput = useRef(null);
  const [show, setSate] = useState(false);
  const ref = useRef();
  const isSmallScreen = useMediaQuery("(max-width:768px)");
  const isMediumScreen = useMediaQuery("(max-width:1024px)");

  const width = isSmallScreen ? "650px" : isMediumScreen ? "465px" : "550px";

  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation();

  useOutsideClick(ref, () => {
    if (show) setSate(false);
  });

  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (e) => {
    setSearchValue(e.target.value.trim());
  };

  const onChangeAddress = (autocomplete) => {
    const place = autocomplete.getPlace();
    if (!place || !place.geometry || !place.geometry.location) {
      console.error("Invalid place object or missing location:", place);
      return;
    }

    const { lat, lng } = place.geometry.location;
    lat_long("latitude", lat());
    lat_long("longitude", lng());

    const selected_city = extractAddress(place).city || extractAddress(place).country || extractAddress(place).state;

    localStorage.setItem("selected_city", selected_city);
    localStorage.removeItem("current_city");
  };

  const initAutocomplete = () => {
    if (!window.google || !window.google.maps || !searchInput.current) return;
    const autocomplete = new window.google.maps.places.Autocomplete(searchInput.current);
    autocomplete.setFields(["address_component", "geometry"]);

    autocomplete.addListener("place_changed", () => onChangeAddress(autocomplete));
  };

  const findMyLocation = (e) => {
    e.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        lat_long("latitude", latitude);
        lat_long("longitude", longitude);
        const city_id = localStorage.getItem("city");
        reverseGeocode({ latitude, longitude }, city_id);
      });
    }
  };

  const reverseGeocode = ({ latitude, longitude }, city_id) => {
    const geocodeJson = `https://maps.googleapis.com/maps/api/geocode/json?key=${apiKey}&latlng=${latitude},${longitude}`;
    searchInput.current.value = "Getting your location...";
    fetch(geocodeJson)
      .then((response) => response.json())
      .then((location) => {
        const place = location.results[0];
        const address = extractAddress(place);
        localStorage.setItem("current_city", address.city);
        localStorage.removeItem("selected_city");
        searchInput.current.value = address.plain();
      })
      .catch((error) => {
        console.error("Error while fetching location: ", error);
        searchInput.current.value = "";
        toast.error("Error fetching location");
      });
  };

  const city_id = localStorage.getItem("city");
  const selected_city = localStorage.getItem("selected_city");
  const current_city = localStorage.getItem("current_city");

  
  const handleSearchButtonClick = () => {
    if (searchValue.trim()) {
      navigate(`/search?keyword=${searchValue}`); 
    }
  };

  return (
    <>
      <div className="desktop-search-bar">
        <Paper
          ref={ref}
          component="form"
          className="searchbar-form desktop-header"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: { width },
            margin: "auto",
          }}
        >
          <div className="searchBar-sec">
            <div>
              <div className="search">
                <input
                  ref={searchInput}
                  type="text"
                  onChange={(e) => handleSearch(e)}
                  defaultValue={current_city ? current_city : selected_city}
                  placeholder={t("search_location")}
                />
                <button onClick={findMyLocation}>
                  <MyLocationIcon className="svg-color" />
                </button>
              </div>
            </div>
          </div>

          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <div className="input_dropdown">
            <InputBase
              sx={{ flex: 1 }}
              placeholder={t("search_bar_text")}
              inputProps={{ "aria-label": "search google maps" }}
              onChange={handleSearch}
              onClick={() => setSate(!show)}
            />
           
          </div>
          <IconButton sx={{ p: "10px" }} aria-label="search" onClick={handleSearchButtonClick}>
            <SearchIcon />
          </IconButton>
        </Paper>
      </div>
    </>
  );
}

export default SearchBarNew;
